import { IStoryContent, INewStoryContent, ContainerData, ContainerTypes, EventRow, ProgressTrackerSettingType } from "../types";
import cheerio from 'cheerio';
import { v4 as uuidv4 } from 'uuid';

export const createContainer = (storyContents: IStoryContent[] | INewStoryContent[], entityId?: number, progressTrackerSettings?: ProgressTrackerSettingType[]): {
  updatedStoryContents: IStoryContent[] | INewStoryContent[], containers: ContainerData[]
} => {
  let progressTrackerSettingsData = progressTrackerSettings || [];

  const containers: ContainerData[] = [];
  const updatedStoryContents = storyContents.map(storyContent => {
    const chartConfig = storyContent.contentChartConfig;
    if (chartConfig && chartConfig.length > 0) {
      const $ = cheerio.load(storyContent.content, {
        xmlMode: false,
        decodeEntities: false
      });
      const progressTracker = $('div[data-media-type="progress-tracker"]').first();
      let progressTrackerId = progressTracker.attr('id');
      if (!progressTrackerId) {
        const uniqueId = uuidv4();
        progressTrackerId = `progress-tracker-${uniqueId}`;
        progressTracker.attr('id', progressTrackerId);
      }
      containers.push({
        id: progressTrackerId,
        type: ContainerTypes.PROGRESS_TRACKER_CONTAINER,
        data: {
          ...chartConfig[0].config,
          progressTrackerSettings: progressTrackerSettingsData
        }
      });
      // Return the story content with updated HTML
      return {
        ...storyContent,
        content: $.html()
      };
    }
    return storyContent;
  });
  return { updatedStoryContents, containers };
};



export const getVerticalTimelineHeight = (events: EventRow[]): number => {
  const eventCount = events.length;
  return Math.max(eventCount * 100, 500);
};